import React from 'react'
import CaseStudyHeader from '../../components/Header/CSHeader/CaseStudyHeader.jsx'

import './ERP.scss'
import '../../base-styles/cs-global.scss'
import productsimg from './assets/products.webp';
import competitorslogo from './assets/competitorslogo.webp';

import featurelist from './assets/featurelist.png';
import ERPcover1 from './assets/ERPcover1.webp';
import ERPcover2 from './assets/ERPcover2.webp';
import ERPcover3 from './assets/ERPcover3.webp';
import ERPcover4 from './assets/ERPcover4.webp';
import xeroswot from './assets/xeroswot.webp';
import odooswot from './assets/odooswot.webp';
import painpoints from './assets/painpoints.webp';

import design1 from './assets/design1.webp';
import design2 from './assets/design2.webp';
import design3 from './assets/design3.webp';



function ERP() {
    return (

        <section>

            <CaseStudyHeader Pagetitle="Internal tools to manage business operations" />

            <div className='cover-container'>

                <img className='cover-img bottom-m' src={ERPcover1} alt="" />
                <img className='cover-img' src={ERPcover2} alt="" />
                <img className='cover-img' src={ERPcover3} alt="" />
                <img className='cover-img' src={ERPcover4} alt="" />

            </div>


            <div className="top-l"></div>

            <div className='cs-content'>

                <h2>Designing internal tools to manage business operations / ERPs.</h2>

            </div>



            <div className='cs-content'>

                <p className="md">
                    'Nathan Digital' is one of the companies under the Nathan Group, based in Dubai, and is focused on building tools for business operations (ERPs). The ERP offering is a suite of five integrated software modules designed to work seamlessly together. what sets nathan digital apart from competitors is the ability to fully customize the software to match each client's unique business requirements.  <br /> <br />

                    To enable this level of customization, I built a robust base ERP system on par with market leaders, and then layered client-specific workflows on top to meet their precise operational needs.
                </p>

            </div>



            <div className='cs-content'>

                <h4>The Products</h4>

                <p className=''>In very simple terms the software was internal tools for handling business operation of different departments in a company also known as ERPs - They were a ecosystem of 5 softwares that is integrated with each other </p>

                {/* <ul>
                    <li>HR Management System - For managing employee data, attendance, payroll etc.</li>
                    <li>Inventory Management System - For tracking stock, purchases, and sales</li>
                    <li>Project Management System - For managing projects, tasks and team collaboration</li>
                    <li>Customer Relationship Management (CRM) - For managing customer interactions and sales pipeline</li>
                    <li>Finance Management System - For accounting, invoicing and financial reporting</li>
                </ul> */}

                <img src={productsimg} alt="" />

            </div>



            <div className='cs-content'>

                <h4>My role and the team</h4>

                <p className=''>I initially joined the team as the first product designer working under the product manager. the only information that was given to me from the small team was what software we are looking to  build and a very short list of features.

                    later as the sales grew so did the design team, i was promoted to a team lead, leading 12 designers across two cities both in dubai and kenya. including juniors in kenya who we had to mentor, train and bring on par with the design quality.</p>


            </div>



            <div className='cs-content'>

                <h2>Design Process : accounting system</h2>

                {/* <h4>Design Process</h4> */}

                <p className="md">This case study is a condensed overview of the work I carried out over multiple years. Documenting all six software systems in detail would be overwhelming, so I’ll be focusing solely on the accounting system. Since I’ve only kept very concise documentation, the case study below is based on my best recollection of the process. Additionally, as the project is under a non-disclosure agreement (NDA), I won’t be sharing any proprietary information, designs, or internal details. The primary goal is to highlight what I’ve done and what I’m capable of—rather than providing an in-depth breakdown of every step.</p>


            </div>



            <div className='cs-content'>

                <h4>Studying the Competitive Landscape, studying their strength and weakness</h4>

                <p className="">I started by looking into the top competitors in the UAE market to create a benchmark for my design. After speaking with our in-house accountants and doing some online research, I identified three major platforms—Intuit QuickBooks, Xero, and Odoo.</p>

                <img src={competitorslogo} alt="" />

                <p className="">Before going into creating a list of features, I performed a SWOT analysis to identify the key advantages, limitations, opportunities, and threats within the competitive landscape. This helped me get an initial understanding of the market and user needs. However, I have not yet dug deep into the gaps, as I will be researching more on this to uncover deeper insights and refine the product strategy.</p>

                <img src={xeroswot} alt="" />

                <img src={odooswot} alt="" />

                <p className="">The SWOT analysis showed that while each competitor has strong points—like QuickBooks’ popularity, Xero’s easy collaboration, and Odoo’s flexibility—they also have clear downsides. Common issues include high pricing, limited customization, and complicated setup. This shows there’s a real opportunity to create an accounting product that’s affordable, easy to use, and tailored for small businesses in the UAE.</p>


            </div>



            <div className='cs-content'>

                <h4>Putting together the list of features</h4>

                <p>
                    Next, I made a list of required features. This included all the key features offered by the competitors, as well as any additional ones that could improve the user experience or meet specific needs in our market. The goal was to make sure our product would cover all the essentials while also offering something better or more user-friendly.
                </p>


                <img src={featurelist} alt="" />


            </div>

            <div className='cs-content'>

                <h4>Identify pain points, areas of cognitive load</h4>

                <p>
                    Before starting the wireframes, I researched the common pain points users had with competing products. I found a lot of helpful feedback on websites, forums, and Reddit—many users were repeatedly complaining about the same issues. We also reviewed the user flows of competitors and compared them to each other to see which parts felt smooth and easy, and where users were likely to feel confused or overwhelmed. I used these insights during the wire framing process to address those problems and design a more intuitive, user-friendly experience.

                </p>

                <img src={painpoints} alt="" />

            </div>

            <div className='cs-content'>

                <h4>Wire-framing stories</h4>
                <p>
                    Keeping all these points in mind, I began wireframing the product story by story. This phase took quite a bit of time and was one of the most hectic and challenging parts of the process, filled with a lot of decision-making and moments of uncertainty. Balancing user needs, technical feasibility, and business goals required constant adjustments and iteration.

                </p>

                <img src="https://www.placehold.co/1000x600" alt="" />

            </div>

            <div className='cs-content'>

                <h4>Conduct heuristic evaluations</h4>

                <p>
                    This part of casestudy is extensive, working on writing this part of the case study. will be posting soon.

                </p>


            </div>

            <div className='cs-content'>

                <h4>Design system and High Fidelity Design</h4>

                <p>
                    During the wireframing process, I realized that the software had a large number of screens. To ensure consistency and make the design scalable, it became clear that a design system was necessary. I took the initiative to advocate for this approach and began building the core components of the design system alongside the wireframes. i have written a full case study on the N1 design system

                </p>

                <p>
                    Once I had the basic components ready, I started designing the accounting software using Nathan Digital's branding. We chose the Manrope font because it looked clean and was easy to read at smaller sizes and looked neat at title sizes—and everyone in the team aligned with the looks of it. Blue was used as the primary color to match the branding and conveyed reliability and professionalism. Here’s how the MVP design looked,

                </p>

                <img src={design1} alt="" />

                <img src={design2} alt="" />

                <img src={design3} alt="" />


            </div>

            <div className='cs-content'>

                <h4>Identify friction points, cognitive load flows and A/B testing</h4>

            </div>




        </section>


    )
}

export default ERP